import Vue from "vue";
import formWheelTyre from "./components/form-wheel-tyre.vue";
import store from "./store";
import "./assets/main.scss";
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuelidate from 'vuelidate';
import { email } from "vuelidate/lib/validators";

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(Vuelidate);

// Registrera wheel tyre-formuläret i ModalManager
if (window.modalManager) {
    window.modalManager.registerFormType('wheel-tyre', {
        Vue: Vue,
        formComponent: formWheelTyre,
        store: store
    });
}

/**
 * Global function to create and mount a wheel tyre form app
 * Now uses ModalManager for centralized form handling
 * @param {string} selector - CSS selector for the target DOM element
 * @param {Object} props - Optional props to override element attributes
 * @returns {Vue|undefined} The mounted Vue instance, or undefined on error
 * @global
 */
window.createApp_wheel_tyre = function(selector, props = {}) {
    if (!window.modalManager) {
        console.error('ModalManager not available for createApp_wheel_tyre');
        return;
    }

    // Registrera wheel tyre-formuläret om det inte redan är registrerat
    if (!window.modalManager.isFormTypeRegistered('wheel-tyre')) {
        window.modalManager.registerFormType('wheel-tyre', {
            Vue: Vue,
            formComponent: formWheelTyre,
            store: store
        });
    }

    return window.modalManager.createFormApp('wheel-tyre', selector, props);
};

/**
 * Automatically initializes all wheel tyre forms found in the DOM
 * Now uses ModalManager for centralized form handling
 * @returns {boolean} True if forms were found and processed, false if no forms exist
 */
let renderWheelTyreForms = function() {
    // Early exit if no forms exist on page
    const forms = document.querySelectorAll('.form-wheel-tyre');
    if (forms.length === 0) {
        return false;
    }

    if (!window.modalManager) {
        console.error('ModalManager not available for renderWheelTyreForms');
        return false;
    }

    // Registrera wheel tyre-formuläret i ModalManager om det inte redan är registrerat
    if (!window.modalManager.isFormTypeRegistered || !window.modalManager.isFormTypeRegistered('wheel-tyre')) {
        window.modalManager.registerFormType('wheel-tyre', {
            Vue: Vue,
            formComponent: formWheelTyre,
            store: store
        });
    }

    forms.forEach((form, index) => {
        try {
            const parentBlock = form.closest('.nitea-form-selector');

            if (parentBlock) {
                // Inbäddade block initieras av form-selector/view.js (undvik dubbel mount)
                return;
            }


                // Footer/manual context: Force modal mode by setting display mode to modal
                if (!form.id) {

                    form.id = `form-wheel-tyre-footer-${Date.now()}-${index}`;

                }

                window.modalManager.createFormApp('wheel-tyre', `#${form.id}`, {
                    displayMode: 'modal'
                });
        } catch (error) {
            console.error(`Failed to initialize wheel tyre form ${index}:`, error);
        }
    });

    return true;
};

// ====================
// INITIALIZATION
// ====================

/**
 * Initialize forms when DOM is ready
 * Handles both immediate execution (if DOM already loaded) and deferred execution
 */
if (document.readyState === 'loading') {
    // DOM not yet loaded, wait for it
    document.addEventListener('DOMContentLoaded', renderWheelTyreForms);
} else {
    // DOM already loaded, initialize immediately
    renderWheelTyreForms();
}

// ====================
// DEBUGGING API
// ====================

/**
 * Expose renderWheelTyreForms globally for debugging and manual re-initialization
 * @global
 */
window.renderWheelTyreForms = renderWheelTyreForms;
